import supabase from "../helpers/init-supabase";

const current_date = new Date().toISOString().split("T")[0];

export const getEducations = async () => {
  try {
    const resp = await supabase
      .from('educations')
      .select('*')
      .eq('is_published', true)
      .gte('application_deadline', current_date);

      if (resp.error) {
        throw resp.error;
      }

      return resp.data;
  } catch (error) {
    throw error;
  }
};

/**
 *
 * @param educationFaunaID - Fauna ID of the education
 */
export function GetEducationByID(educationFaunaID) {
  return supabase
    .from('educations')
    .select('*')
    .eq('fauna_id', educationFaunaID)
    .single()
    .then(resp => {
      if (resp.error) {
        throw resp.error;
      }
      return { data: resp.data };
    })
    .catch(error => ({ error }));
}
